import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { label: 'Services', id: 'services' },
    { label: 'About', id: 'about' },
    { label: 'Process', id: 'process' },
    { label: 'Service Areas', id: 'service-areas' },
    { label: 'FAQs', id: 'faqs' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-32">
            {/* Logo with Text */}
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center space-x-4 cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/b0e02ac5bb5a665ef5e4799404f79cfa.png" 
                alt="X-Treme Aqua Pressure Cleaning"
                className="h-24 w-auto object-contain rounded-xl shadow-lg"
              />
              <div className="flex flex-col">
                <span className="text-3xl font-extrabold leading-tight text-blue-900">
                  X-Treme Aqua
                </span>
                <span className="text-lg font-bold leading-tight text-cyan-500">
                  Pressure Cleaning
                </span>
              </div>
            </button>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-sm font-medium text-blue-900 hover:text-cyan-500 transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>

            {/* Desktop CTAs */}
            <div className="hidden lg:flex items-center space-x-4">
              <a
                href="tel:3052793585"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-orange-400 to-orange-500 text-white text-sm font-bold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call (305) 279-3585
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-sm font-bold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
              >
                Get Quote
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 rounded-lg text-blue-900 hover:bg-blue-50 transition-colors"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-blue-900/95 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)}></div>
          <div className="absolute top-32 left-0 right-0 bg-white shadow-xl rounded-b-2xl p-6 space-y-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left px-4 py-3 text-blue-900 hover:bg-cyan-50 rounded-lg transition-colors font-medium"
              >
                {link.label}
              </button>
            ))}
            <div className="pt-4 space-y-3">
              <a
                href="tel:3052793585"
                className="flex items-center justify-center px-6 py-3 bg-gradient-to-r from-orange-400 to-orange-500 text-white font-bold rounded-full hover:shadow-lg transition-all whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call (305) 279-3585
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="flex items-center justify-center w-full px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full hover:shadow-lg transition-all whitespace-nowrap"
              >
                Get Quote
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating Mobile Call Button */}
      <a
        href="tel:3052793585"
        className="lg:hidden fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-r from-orange-400 to-orange-500 text-white rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform duration-300"
      >
        <i className="ri-phone-fill text-2xl"></i>
      </a>
    </>
  );
}
